<template>
  <div class="content" v-if="ads">
    <p class="page-title">Kiosk Ads</p>
    <div class="card">
      <p class="title">Create a Kiosk url</p>
      <div class="inputs">
        <div class="input">
          <label>Location</label>
          <v-select
            :options="locations"
            label="name"
            :clearable="false"
            :reduce="(d) => d.slug"
            v-model="location"
          >
            <template v-slot:option="option">
              <div>
                {{
                  `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="input">
          <label>Form</label>
          <v-select
            :options="forms"
            label="title"
            :clearable="false"
            :reduce="(d) => d.slug"
            v-model="form"
          >
            <template v-slot:option="option">
              <div>{{ option.title }}</div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="btns left">
        <button
          :class="{ disabled: !form || !location }"
          @click="getUrl()"
          class="btn round-btn"
        >
          Get Kiosk Url
        </button>
        <button @click="showVideo()" class="btn text_btn text">
          How to view kiosk in browser?
        </button>
      </div>
    </div>
    <div v-if="ads == 'none'" class="card">
      <div class="kiosk-intro">
        <div class="text">
          <p class="subtitle">You currently have no ads</p>
          <h2>Customize your Kiosk!</h2>
          <p>
            Start by clicking below. You can add images, or videos to display on
            the bottom half of your kiosk!
          </p>
          <button @click="newAd()" class="btn">Add content</button>
        </div>
        <img src="@/assets/img/kiosk_content.png" />
      </div>
    </div>

    <div v-if="ads.length && ads != 'none'" class="card">
      <p class="title">
        Your Ads
        <button @click="newAd()" class="btn round-btn">New Ad</button>
      </p>
      <div class="table-holder">
        <table>
          <thead>
            <tr>
              <th>Order</th>
              <th>Media</th>
              <th>Name</th>
              <th>Active</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <template v-if="ads.length">
            <draggable tag="tbody" v-model="ads" @change="updateSlideOrder()">
              <tr
                v-for="(item, i) in ads"
                :key="i"
                :class="{ grey: i % 2, saved: ads_updated }"
              >
                <td>
                  <img class="order" src="@/assets/img/order.svg" />
                </td>
                <td data-label="Media">
                  <div class="media">
                    <img
                      v-if="!item.type.includes('video')"
                      :src="item.media"
                    />
                    <video
                      v-if="item.type.includes('video')"
                      :src="item.media"
                    ></video>
                  </div>
                </td>
                <td data-label="Name">{{ item.name }}</td>
                <td data-label="Active">
                  <!-- {{ item.active ? "Active" : "Inactive" }} -->
                  <div class="switch-holder">
                    <span style="margin-right: 15px">{{
                      item.active ? "Active" : "Inactive"
                    }}</span>
                    <div @click="saveAd(i)">
                      <switches v-model="item.active"></switches>
                    </div>
                  </div>
                </td>
                <td data-label="Edit">
                  <img
                    @click="handleEdit(item)"
                    class="action clickable"
                    src="@/assets/img/edit.svg"
                  />
                </td>
                <td data-label="Edit">
                  <img
                    @click="handleDelete(item)"
                    class="action clickable"
                    src="@/assets/img/delete.svg"
                  />
                </td>
              </tr>
            </draggable>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
import draggable from "vuedraggable";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const storage = fb.default.storage;
const auth = fb.default.auth;

export default {
  name: "KioskAds",
  components: {
    Switches,
    draggable,
  },
  data() {
    return {
      ads: null,
      locations: null,
      location: null,
      forms: null,
      form: null,
      ads_updated: null,
    };
  },
  firestore() {
    return {
      locations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations"),
      forms: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("forms"),
    };
  },
  async created() {
    await this.getAffiliates();
    db.collection("user")
      .doc(this.user_doc.id)
      .collection("kiosk_ads")
      .orderBy("order")
      .get()
      .then((doc) => {
        if (doc.docs.length) {
          let docs = doc.docs.map((ad) => {
            let data = ad.data();
            data.id = ad.id;
            return data;
          });
          this.ads = docs;
        } else {
          this.ads = "none";
        }
      });
  },
  methods: {
    newAd() {
      let id = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("kiosk_ads")
        .doc().id;
      this.goTo("/ad/" + id);
    },
    handleEdit(item) {
      this.goTo("/ad/" + item.id);
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("kiosk_ads")
            .doc(item.id)
            .delete()
            .then(() => {
              this.getAds();
              Swal.fire("Deleted!", `The ad has been deleted.`, "success");
            });
        }
      });
    },
    getAds() {
      db.collection("user")
        .doc(this.user_doc.id)
        .collection("kiosk_ads")
        .orderBy("order")
        .get()
        .then((snapshot) => {
          if (snapshot.docs.length) {
            this.ads = snapshot.docs.map((ad) => {
              let data = ad.data();
              data.id = ad.id;
              return data;
            });
          }
        });
    },
    getUrl() {
      window.open(
        `https://covid19pad-kiosk.web.app/${this.user_doc.slug}/${this.form}/${this.location}`,
        "_blank"
      );
    },
    showVideo() {
      window.open(config.KIOSK_AD_VIDEO, "_blank");
    },
    saveAd(i) {
      setTimeout(() => {
        let ad = this.ads[i];
        db.collection("user")
          .doc(this.user_doc.id)
          .collection("kiosk_ads")
          .doc(ad.id)
          .set(ad)
          .then((result) => {
            Swal.fire(
              `Ad ${ad.name ? "(" + ad.name + ")" : ""} is now ${
                ad.active ? "active" : "inactive"
              }`
            );
          });
      }, 500);
    },
    updateSlideOrder() {
      var batch = db.batch();
      this.ads.forEach((ad, i) => {
        this.ads[i].order = i + 1;
        let ref = db
          .collection("user")
          .doc(this.user_doc.id)
          .collection("kiosk_ads")
          .doc(ad.id);
        batch.update(ref, ad);
      });
      batch.commit().then(() => {
        this.ads_updated = true;
        setTimeout(() => {
          this.ads_updated = false;
        }, 500);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.kiosk-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  max-width: 1000px;
  & > div {
    @media screen and (max-width: 650px) {
      width: 100%;
    }
    width: 49%;
    .subtitle {
      color: #00bf6f;
      font-weight: bold;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 50px;
      @media screen and (max-width: 1000px) {
        font-size: 40px;
      }
    }
    .btn {
      margin-top: 20px;
    }
  }
  img {
    width: 49%;
    max-width: 250px;
    @media screen and (max-width: 650px) {
      width: auto;
      margin-top: 30px;
      max-height: 400px;
    }
  }
}

.media img,
.media video {
  max-width: 100px;
  max-height: 100px;
}

.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.text_btn {
  font-size: 14px;
  padding: 0 20px;
  text-decoration: underline;
  -ms-text-underline-position: under;
}

.order {
  height: 25px;
  opacity: 0.5;
  padding: 5px;
  cursor: grab;
  margin-right: auto;
}

.order:hover {
  cursor: grab;
}

tr {
  transition: all 0.5s;
}

tr.saved {
  background: rgb(0 191 111 / 25%);
}
</style>
